enum TypeofSupport {
  Onlyaworkout = 'Only a workout and nutrition tracking tool',
  Personalized = 'Personalized workout and nutrition coaching',
  Both =  '⁠Both a tracker and coaching',
  Other = 'Other',
}

const typeofsupportQuestion = {
  name: 'typeofsupport',
  title: 'What are you looking for?',
  description: 'This just helps us understand what kind of support you’re after.',
  type: 'radiogroup',
  choices: [
    {
      value: TypeofSupport.Onlyaworkout,
      text: "<div class='icon-button'><div>📊</div><div>Smarter tracking<br /><span class=\"small-text\">I want powerful tools to log, analyze, and optimize my workouts and nutrition</span></div></div>",
    },
    {
      value: TypeofSupport.Personalized,
      text: "<div class='icon-button'><div>🧑‍🏫</div><div>Guidance<br /><span class=\"small-text\">I want expert help to guide my fitness journey</span></div></div>",
    },
    {
      value: TypeofSupport.Both,
      text: "<div class='icon-button'><div>🤝</div><div>Both<br /><span class=\"small-text\">I want tracking and personalized support</span></div></div>",
    },
  ],
  isRequired: true,
};

export {
  TypeofSupport,
  typeofsupportQuestion,
};